var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.108,
    height: 36.472,
    viewBox: "0 0 46.108 36.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.375,27.4l-7.6,7.6-2.981-2.981a2.313,2.313,0,1,0-3.282,3.259L21.13,39.9a2.311,2.311,0,0,0,3.282,0l9.245-9.245A2.313,2.313,0,1,0,30.375,27.4ZM39.92,13.833A16.179,16.179,0,0,0,9.042,18.225a9.245,9.245,0,0,0-.878,17.681,2.311,2.311,0,1,0,1.479-4.322,4.649,4.649,0,0,1,1.572-9.014,2.311,2.311,0,0,0,2.311-2.311,11.556,11.556,0,0,1,22.488-3.7,2.311,2.311,0,0,0,1.8,1.525,6.934,6.934,0,0,1,.555,13.5,2.329,2.329,0,1,0,.578,4.622h.578a11.556,11.556,0,0,0,.393-22.234Z",
    transform: "translate(-2.023 -4.115)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheck);
export default __webpack_public_path__ + "static/media/cloud-check.1201646bbe15153c533d2a7580d78cec.svg";
export { ForwardRef as ReactComponent };